import type {
	ServicePeriodStatusValue,
	UnitPayoutStatusValue,
} from "./financialShared.types";
import { ServicePeriodStatus, UnitPayoutStatus } from "./financialShared.types";

export function formatAed(amount: number): string {
	return `AED ${amount.toLocaleString("en-AE")}`;
}

export function getServicePeriodStatusBubbleClasses(
	status: ServicePeriodStatusValue | null | undefined,
): { bgClassName: string; textClassName: string } {
	switch (status) {
		case ServicePeriodStatus.PUBLISHED:
			return {
				bgClassName: "bg-[var(--color-status-active-bg)]",
				textClassName: "text-status-active",
			};
		case ServicePeriodStatus.COMPLETED:
			return {
				bgClassName: "bg-[var(--color-status-active-bg)]",
				textClassName: "text-status-active",
			};
		case ServicePeriodStatus.DRAFT:
			return {
				bgClassName: "bg-[var(--color-status-invited-bg)]",
				textClassName: "text-status-invited",
			};
		default:
			return {
				bgClassName: "bg-bg-input",
				textClassName: "text-primary-muted",
			};
	}
}

export function getUnitStatusBubbleClasses(status: UnitPayoutStatusValue): {
	bgClassName: string;
	textClassName: string;
} {
	switch (status) {
		case UnitPayoutStatus.SETTLED:
			return {
				bgClassName: "bg-[var(--color-status-active-bg)]",
				textClassName: "text-status-active",
			};
		case UnitPayoutStatus.IN_PROGRESS:
		case UnitPayoutStatus.OUTSTANDING:
		case UnitPayoutStatus.PARTIALLY_PAID:
			return {
				bgClassName: "bg-[var(--color-status-invited-bg)]",
				textClassName: "text-status-invited",
			};
		case UnitPayoutStatus.CREDIT:
			return {
				bgClassName: "bg-[var(--color-status-active-bg)]",
				textClassName: "text-status-active",
			};
		case UnitPayoutStatus.PAST_DUE:
			return {
				bgClassName: "bg-status-invite-expired-bg",
				textClassName: "text-status-invite-expired",
			};
		case UnitPayoutStatus.HOLD:
			return {
				bgClassName: "bg-bg-input",
				textClassName: "text-primary-muted",
			};
		default:
			return {
				bgClassName: "bg-bg-input",
				textClassName: "text-primary-muted",
			};
	}
}

export function getUnitStatusClass(status: UnitPayoutStatusValue): string {
	const { bgClassName, textClassName } = getUnitStatusBubbleClasses(status);
	return `inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium ${bgClassName} ${textClassName}`;
}

export function getServicePeriodStatusClass(
	status: ServicePeriodStatusValue | null | undefined,
): string {
	const { bgClassName, textClassName } =
		getServicePeriodStatusBubbleClasses(status);
	return `inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium ${bgClassName} ${textClassName}`;
}

export function chargesCategoryBubbleClasses(category: string): {
	bgClassName: string;
	textClassName: string;
} {
	if (category.includes("Common Area")) {
		return {
			bgClassName: "bg-[var(--color-status-invited-bg)]",
			textClassName: "text-status-invited",
		};
	}
	if (category.includes("Utilities")) {
		return {
			bgClassName: "bg-[var(--color-status-active-bg)]",
			textClassName: "text-status-active",
		};
	}
	return {
		bgClassName: "bg-[var(--color-status-uninvited-bg)]",
		textClassName: "text-status-uninvited",
	};
}

export function chargesCategoryClass(category: string): string {
	const { bgClassName, textClassName } = chargesCategoryBubbleClasses(category);
	return `${bgClassName} ${textClassName}`;
}

export const FINANCIAL_AMOUNT_POSITIVE_CLASS = "font-medium text-status-active";
export const FINANCIAL_AMOUNT_PARTIAL_CLASS = "font-medium text-status-invited";
export const FINANCIAL_AMOUNT_BALANCE_CLASS = "font-medium text-accent";
export const FINANCIAL_SUMMARY_GRAND_TOTAL_CLASS = "bg-bg-input font-semibold";

export const FINANCIAL_TABLE_CELL_CLASS = "px-4 py-3";
export const FINANCIAL_TABLE_CELL_MUTED_CLASS = "px-4 py-3 text-primary-muted";
export const FINANCIAL_TABLE_CELL_PRIMARY_CLASS = "px-4 py-3 text-primary";
export const FINANCIAL_TABLE_CELL_RIGHT_CLASS = "px-4 py-3 text-right";

export function toApiSortOrder(
	dir: "asc" | "desc" | "ASC" | "DESC" | undefined,
): "ASC" | "DESC" {
	return dir === "desc" || dir === "DESC" ? "DESC" : "ASC";
}
